module.exports = __webpack_public_path__ + "static/media/ic-attach-file.509b396c.svg";